<template>
  <HoverMenu v-if="id"
             :nudgeamount="-3"
             :disabled="!ParentCustomer">
    <template v-slot:menu-activator>
      <AreaLi :label="$t('servicesystem.common_objects.customer.parent_org')"
              :value="ParentCustomer ? ParentCustomer.Name : ''"
              :loading="loading">
        <template v-slot:value>
          <div v-if="loading">
            <v-skeleton-loader class="ml-3"
                               type="text"
                               height="28"
                               width="30%">
            </v-skeleton-loader>
          </div>
          <a v-else-if="ParentCustomer"
             :href="getRoute({ page: 'ViewCustomer', params: { customerId: ParentCustomer.Id }, guiver: 'new', travel: false })"
             class="d-flex px-3 pb-2 text-decoration-none">
            <v-icon size="16"
                    class="mr-2"
                    :color="color"
                    v-text="'$customer'" />
            <v-list-item-title v-text="ParentCustomer ? ParentCustomer.Name : ''"
                               :class="[(color + '--text'), 'nowrapheader']" 
                               style="font-size: 14px !important;"/>
          </a>
          <div v-else
               class="px-3 pb-2 error--text">
            {{$t('servicesystem.common_objects.fallbackterms.failed_to_get')}}
          </div>
        </template>
      </AreaLi>
    </template>
    
    <template v-slot:menu-content>
      <v-progress-circular v-if="loading"
                           indeterminate
                           color="primary">
      </v-progress-circular>
      <v-container v-else-if="!loading && ParentCustomer"
                   class="pa-0"
                   fluid>
        <v-row no-gutters>
          <v-col cols="3">
            <AreaLi :label="$t('servicesystem.common_objects.customer.customer_number')"
                    :value="ParentCustomer.Id" />
          </v-col>
          <v-col cols="9">
            <AreaLi :label="$t('servicesystem.common_objects.customer.customer_name')"
                    :value="ParentCustomer.Name" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">
            <SwitchLi :label="$t('servicesystem.common_objects.customer.free_from_vat')"
                      :value="ParentCustomer.FreeFromVat" />
          </v-col>
          <v-col cols="9">
            <AreaLi :label="$t('servicesystem.common_objects.customer.organization_number')"
                    :value="ParentCustomer.OrganisationNumber" />
          </v-col>
        </v-row>
        <v-row no-gutters
               v-if="ParentCustomer.CreditLimit">
          <v-col cols="8">
            <AreaLi :label="$t('servicesystem.common_objects.customer.credit_limit')"
                    :value="ParentCustomer.CreditLimit" />
          </v-col>
          <v-col cols="4">
            <AreaLi :label="$t('servicesystem.common_objects.customer.credit_block')"
                    :value="ParentCustomer.CreditLimitExceeded" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </HoverMenu>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import AreaLi from "@/components/Inputs/AreaListItem.vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
  name: "ParentCustomerCard",
  props: ["id"],
  components: {
    SwitchLi,
    AreaLi,
    HoverMenu,
  },
  mixins: [clientAPI],

  data() {
    return {
      ParentCustomer: null,
      loading: false,
    };
  },

  mounted() {
    this.getCustomer();
  },

  methods: {
    getCustomer() {
      if (this.id) {
        this.loading = true;
        this.getCustomerById(this.id)
          .then((response) => {
            this.ParentCustomer = response;
            
          })
          .catch((exception) => {
            console.error(exception);
            this.ParentCustomer = null;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.ParentCustomer = null;
      }
    },
  },

  computed: {
    color() {
      if (this.ParentCustomer) {
        return this.ParentCustomer.IsActive ? "primary" : "disabled";
      } else {
        return "";
      }
    },
  },

  watch: {
    id: function () {
      this.getCustomer();
    },
  },
};
</script>

<style lang="scss">
</style>